/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, Input } from "@angular/core";
import { IndexableObject } from "ng-zorro-antd/core/types";
import { NzRowDirective } from "ng-zorro-antd/grid";
import { GridAlign, GridJustify } from "@webapp/ui/grid/grid.models";

@Directive({
  selector: "[ui-row],ui-row,ui-form-item",
  exportAs: "uiRow",
  host: {
    "[class.ant-row-top]": `nzAlign === 'top'`,
    "[class.ant-row-middle]": `nzAlign === 'middle'`,
    "[class.ant-row-bottom]": `nzAlign === 'bottom'`,
    "[class.ant-row-start]": `nzJustify === 'start'`,
    "[class.ant-row-end]": `nzJustify === 'end'`,
    "[class.ant-row-center]": `nzJustify === 'center'`,
    "[class.ant-row-space-around]": `nzJustify === 'space-around'`,
    "[class.ant-row-space-between]": `nzJustify === 'space-between'`,
    "[class.ant-row-rtl]": `dir === "rtl"`,
  },
})
export class UiRowDirective extends NzRowDirective {
  @Input("rowAlign") nzAlign: GridAlign | null = null;
  @Input("rowJustify") nzJustify: GridJustify | null = null;
  @Input("rowGutter") nzGutter: string | number | IndexableObject | [number, number] | [IndexableObject, IndexableObject] | null = null;
}
